const getCdn = () => {
  const url = process.env.VUE_APP_CDN_URL;
  if (!url) {
    throw new Error('Failed to get cdn url');
  }
  return url;
};

const getCdnAgentAvatar = (filename) => {
  if (filename) {
    return `${getCdn()}/img/agent/${filename}`;
  }
  return null;
};

export default {
  getCdn,
  getCdnAgentAvatar,
};
